import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import radAnalysis from "../../Assets/Projects/rad_analysis.png";
import oncoVision from "../../Assets/Projects/onco_vision.png";
import fireEvacuation from "../../Assets/Projects/fire_evacution.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={radAnalysis}
              isBlog={false}
              title="RadAnalysis - High-Performance Pipeline for Biomedical Image Analysis"
              description="End-to-end pipeline integrating U-Net and nnU-Net with optimized data flows, achieving 28x faster inference (14.2 min → 30 sec) while maintaining 93.1% Dice accuracy on longitudinal neuroimaging datasets. Deployed real-time services supporting 45 concurrent radiologists and 180+ studies/day."
              ghLink="https://github.com/Ratim321"
              demoLink="https://rad-analysis.diagnotech-ai.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={oncoVision}
              isBlog={false}
              title="OncoVision: Multimodal AI for Breast Cancer Diagnosis"
              description="Multimodal AI pipeline combining mammography images and clinical data to segment four ROIs and predict ten structured clinical features with state-of-the-art accuracy. Deployed as a secure, web-based platform with attention-weighted visualizations and dual-confidence scoring."
              ghLink="https://github.com/Ratim321"
              demoLink=""
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={fireEvacuation}
              isBlog={false}
              title="LLM-Based Evacuation Planning System"
              description="Evacuation simulation system using large language models for path planning under dynamic hazards, integrating floor-plan parsing and agent-based physics. Implemented advanced reasoning strategies (Chain-of-Thought, Tree-of-Thought, Reflexion) improving path-selection accuracy by 32%."
              ghLink="https://github.com/Ratim321"
              demoLink=""
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
